import { Box, Icon, Spacer, Text } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import * as React from 'react'
import { Modal, ModalTypes } from '../../../comps/ModalWeb'
import { useWindowDimensions } from '../../../util/util'
import { styles } from './styles'
import UserSettings from './UserSettings'

interface ProfileSettingsProps {
  mercName: string
}

const getSelectedMIDView = (mercName: string, breakpoint: number): React.ReactElement => {
  return (
    <Box {...styles(breakpoint).buttonBox}>
      <Icon color="BLACK" id="USER" />
      <Spacer size={8} hide={breakpoint <= 640} direction="horizontal" />
      {breakpoint > 640 && (
        <Text testID={'selectedMid'} {...styles(breakpoint).merchantTitle}>
          {mercName.length < 26 ? mercName : `${mercName.slice(0, 25)}...`}
        </Text>
      )}
    </Box>
  )
}

const ProfileSettings: FC<ProfileSettingsProps> = ({ mercName }: ProfileSettingsProps) => {
  const [showMidSelector, setShowMidSelector] = useState(false)
  const [left, setLeft] = useState(0)
  const viewPortWidth = useWindowDimensions()

  const onPress = (evt: any): void => {
    evt?.preventDefault()
    evt?.nativeEvent?.target?.measure((...args: any) => {
      setLeft(args[4] - 170 - args[0])
      setShowMidSelector((prev) => !prev)
    })
  }

  const handleMidSelectorPress = (): void => {
    setShowMidSelector(false)
  }

  const renderUserSettings = (): React.ReactElement => {
    return <UserSettings onSelected={handleMidSelectorPress} left={left} />
  }

  useEffect(() => {
    setShowMidSelector(false)
  }, [viewPortWidth])

  const getModalType = () => {
    if (viewPortWidth < 620) {
      return ModalTypes.NAVBAR_RIGHT
    }
    return ModalTypes.SELECTOR
  }

  return (
    <>
      <Modal
        view={renderUserSettings()}
        onPress={handleMidSelectorPress}
        visible={showMidSelector}
        type={getModalType()}
      />
      <Box testID={'midSelectorBtn'} underlayColor="TRANSPARENT" onPress={onPress}>
        <Spacer size={15} />
        <Box {...styles(viewPortWidth).merchantBox}>
          {getSelectedMIDView(mercName, viewPortWidth)}
          <Box {...styles(viewPortWidth).buttonOverlayStyle} />
          <Spacer size={5} hide={viewPortWidth <= 640} direction="horizontal" />
          {viewPortWidth > 640 && <Icon color="BLACK" id="ARROW_DOWN" />}
        </Box>
      </Box>
    </>
  )
}

export default ProfileSettings
